import React, { useState } from 'react';
import { 
    Fab, 
} from '@material-ui/core';
import { 
    Keyboard as KeyboardIcon,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { _ } from '../../functions/translator.js';
import './Hotkeys.css';
import HotkeysPanel from './HotkeysPanel.js';

const useStyles = makeStyles((theme) => ({
    fab: {
        position: 'absolute',
        bottom: theme.spacing(2),
        left: theme.spacing(2),
        zIndex: 1000,
        backgroundColor: 'var(--onstageobra-color)',
        color: 'white',
        '&:hover': {
            opacity: 0.5,
            transform: 'scale(1.1)',
            boxShadow: theme.shadows[8],
        },
        boxShadow: theme.shadows[4],
        transition: 'all 0.3s ease',
    },
}));

const HotkeysButton = () => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleMouseEnter = () => {
        setOpen(true);
    };

    const handleMouseLeave = () => {
        setOpen(false);
    };

    return (
        <>
            <Fab
                    size="medium"
                    className={`${classes.fab} hotkeys-button`}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <KeyboardIcon />
            </Fab>
            
            {open && <HotkeysPanel />}
        </>
    );
};

export default HotkeysButton 